(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["max-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('mg-faq');
  if (!section) return;

  var items = section.querySelectorAll('.mg-faq__item');

  items.forEach(function (item) {
    var btn    = item.querySelector('.mg-faq__q');
    var panel  = item.querySelector('.mg-faq__a');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      /* Close all items */
      items.forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('.mg-faq__q');
        var p = el.querySelector('.mg-faq__a');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (p) p.setAttribute('hidden', '');
      });

      /* If it was closed, open it */
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["max-goggle-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /*
    Handles fade-in for uploaded/external file videos only.
    YouTube uses a CSS animation instead since JS events
    are not available across origins.
  */
  document.addEventListener('DOMContentLoaded', function () {
    var section   = document.getElementById('mg-hero');
    if (!section) return;

    var videoWrap = section.querySelector('.mg-hero__video-wrap--file');
    var video     = section.querySelector('.mg-hero__video');
    if (!video || !videoWrap) return;

    var revealed = false;

    function revealVideo() {
      if (revealed) return;
      revealed = true;
      videoWrap.style.opacity = '1';
    }

    function hideVideo() {
      if (revealed) return;
      videoWrap.style.display = 'none';
    }

    video.addEventListener('playing', revealVideo);

    video.addEventListener('canplaythrough', function () {
      if (!video.paused) revealVideo();
    });

    // Give video 5s before giving up and showing image fallback
    var timeout = setTimeout(function () {
      if (!revealed) hideVideo();
    }, 5000);

    video.addEventListener('playing', function () {
      clearTimeout(timeout);
    }, { once: true });

    video.addEventListener('error', function () {
      clearTimeout(timeout);
      hideVideo();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["max-goggle-subnav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap      = document.getElementById('mgSubnavWrap');
  var subnav    = document.getElementById('mgSubnav');
  var inner     = subnav && subnav.querySelector('.mg-subnav__inner');
  var indicator = document.getElementById('mgSubnavIndicator');
  var links     = Array.from(document.querySelectorAll('#mgSubnavLinks .mg-subnav__link'));
  var isSticky  = wrap && wrap.dataset.sticky === 'true';

  if (!wrap || !subnav || !inner) return;

  // Inject spacer
  var spacer = document.createElement('div');
  spacer.className = 'mg-subnav-wrap__spacer';
  wrap.insertBefore(spacer, subnav);

  var sectionIds     = links.map(function(a){ return a.dataset.target; }).filter(Boolean);
  var currentHeaderH = 0;

  // ── Site header detection ────────────────────────────────────────────────
  function getSiteHeader() {
    var selector = wrap.dataset.headerSelector || '';
    var candidates = [selector,
      '#shopify-section-header',
      'header.site-header',
      '.site-header',
      'header[role="banner"]',
      'header'
    ].filter(Boolean);
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return null;
  }

  function applyHeaderHeight(h) {
    currentHeaderH = h;
    wrap.style.setProperty('--subnav-top-offset', h + 'px');
  }

  var headerEl = getSiteHeader();
  if (headerEl && typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(function(entries) {
      applyHeaderHeight(entries[0].contentRect.height);
      updateSticky();
      moveIndicatorToActive();
    });
    ro.observe(headerEl);
    applyHeaderHeight(headerEl.getBoundingClientRect().height);
  }

  // ── Indicator positioning ────────────────────────────────────────────────
  function moveIndicator(link) {
    if (!link || !indicator || !inner) return;
    var innerRect = inner.getBoundingClientRect();
    var linkRect  = link.getBoundingClientRect();
    var left  = linkRect.left - innerRect.left;
    var width = linkRect.width;
    indicator.style.left    = left + 'px';
    indicator.style.width   = width + 'px';
    indicator.style.opacity = '1';
  }

  function moveIndicatorToActive() {
    var active = inner.querySelector('.mg-subnav__link.is-active');
    if (active) moveIndicator(active);
  }

  // ── Active link ──────────────────────────────────────────────────────────
  function setActive(id) {
    links.forEach(function(a){ a.classList.remove('is-active'); });
    var active = inner.querySelector('a[data-target="' + id + '"]');
    if (active) {
      active.classList.add('is-active');
      moveIndicator(active);
    }
  }

  // ── Which section is in view ─────────────────────────────────────────────
  function getActiveSection() {
    var subnavH = subnav.getBoundingClientRect().height || 46;
    var totalOffset = currentHeaderH + subnavH + 8;
    var current = sectionIds[0];
    sectionIds.forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      var top = el.getBoundingClientRect().top;
      if (top <= totalOffset) current = id;
    });
    return current;
  }

  // ── Sticky ───────────────────────────────────────────────────────────────
  var subnavOriginalTop = 0;
  function calcOriginalTop() {
    var wasSticky = wrap.classList.contains('is-sticky');
    if (wasSticky) wrap.classList.remove('is-sticky');
    subnavOriginalTop = wrap.getBoundingClientRect().top + window.scrollY;
    if (wasSticky) wrap.classList.add('is-sticky');
  }
  calcOriginalTop();

  function updateSticky() {
    if (!isSticky) return;
    var shouldStick = (window.scrollY + currentHeaderH) >= subnavOriginalTop;
    var wasSticky = wrap.classList.contains('is-sticky');
    if (shouldStick && !wasSticky) {
      wrap.classList.add('is-sticky');
      requestAnimationFrame(moveIndicatorToActive);
    } else if (!shouldStick && wasSticky) {
      wrap.classList.remove('is-sticky');
      calcOriginalTop();
      requestAnimationFrame(moveIndicatorToActive);
    }
  }

  // ── Scroll ───────────────────────────────────────────────────────────────
  var rafPending = false;
  window.addEventListener('scroll', function() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function() {
      updateSticky();
      setActive(getActiveSection());
      rafPending = false;
    });
  }, { passive: true });

  // ── Resize ───────────────────────────────────────────────────────────────
  window.addEventListener('resize', function() {
    calcOriginalTop();
    updateSticky();
    moveIndicatorToActive();
  }, { passive: true });

  // ── Click: smooth scroll ─────────────────────────────────────────────────
  links.forEach(function(a) {
    a.addEventListener('click', function(e) {
      var href   = a.getAttribute('href') || '';
      var target = a.dataset.target || href.replace('#', '');
      var el     = document.getElementById(target);
      e.preventDefault();
      if (!el) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var subnavH  = subnav.getBoundingClientRect().height || 46;
      var elTop    = el.getBoundingClientRect().top + window.scrollY;
      var scrollTo = elTop - currentHeaderH - subnavH - 4;
      window.scrollTo({
        top: Math.max(0, scrollTo),
        behavior: 'smooth'
      });
    });
  });

  // ── Init ─────────────────────────────────────────────────────────────────
  window.addEventListener('load', function() {
    calcOriginalTop();
    updateSticky();
    moveIndicatorToActive();
  });

  setTimeout(function() {
    calcOriginalTop();
    moveIndicatorToActive();
  }, 400);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutorial-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal    = document.getElementById('mgTpModal');
  var iframe   = document.getElementById('mgTpIframe');
  var titleEl  = document.getElementById('mgTpModalTitle');
  var closeBtn = document.getElementById('mgTpModalClose');

  if (!modal || !iframe) return;

  function openModal(videoId, videoTitle) {
    titleEl.textContent = videoTitle || '';
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    iframe.src = '';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.mg-tp__card:not(.mg-tp__card--ghost)').forEach(function (card) {
    function handleOpen() {
      var id    = card.dataset.videoId;
      var title = card.dataset.videoTitle;
      if (!id) return;
      openModal(id, title);
    }
    card.addEventListener('click', handleOpen);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleOpen();
      }
    });
  });

  closeBtn && closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal    = document.getElementById('mgTutorialsModal');
  var iframe   = document.getElementById('mgTutorialsIframe');
  var titleEl  = document.getElementById('mgTutorialsModalTitle');
  var closeBtn = document.getElementById('mgTutorialsClose');

  if (!modal || !iframe) return;

  function openModal(videoId, videoTitle) {
    titleEl.textContent = videoTitle || '';
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    iframe.src = '';
    document.body.style.overflow = '';
  }

  // Card clicks
  document.querySelectorAll('.mg-tutorials__card').forEach(function (card) {
    function handleOpen() {
      var id    = card.dataset.videoId;
      var title = card.dataset.videoTitle;
      if (!id) return;
      openModal(id, title);
    }
    card.addEventListener('click', handleOpen);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleOpen();
      }
    });
  });

  // Close button
  closeBtn && closeBtn.addEventListener('click', closeModal);

  // Click outside modal inner closes
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
